import { render, staticRenderFns } from "./ZDMActionPreview.vue?vue&type=template&id=66675d72&scoped=true&"
import script from "./ZDMActionPreview.vue?vue&type=script&lang=js&"
export * from "./ZDMActionPreview.vue?vue&type=script&lang=js&"
import style0 from "./ZDMActionPreview.vue?vue&type=style&index=0&id=66675d72&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66675d72",
  null
  
)

export default component.exports